import Ajax from '../../../../common/js/Ajax.js';
import CartWidget from '../../../../common/js/cart/CartWidget.js';
import Form from '../../../../common/js/form/Form.js';
import LangUtils from '../../../../common/js/LangUtils.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import UrlParser from '../../../../common/js/UrlParser.js';
import Widget from '../../../../common/js/Widget.js';

import contactEmail from '../../../../common/js/handlebars/contactEmail.js';

import MAIN_DE_TEMPLATE from './CompleteOrderWidget-de.hbs';
import MAIN_EN_TEMPLATE from './CompleteOrderWidget-en.hbs';
import SUCCESS_DE_TEMPLATE from './CompleteOrderWidget-success-de.hbs';
import SUCCESS_EN_TEMPLATE from './CompleteOrderWidget-success-en.hbs';
import WAIT_DE_TEMPLATE from './CompleteOrderWidget-wait-de.hbs';
import WAIT_EN_TEMPLATE from './CompleteOrderWidget-wait-en.hbs';

export default class CompleteOrderWidget extends Widget {

	constructor($widget) {
		super($widget);

		var params = UrlParser.getParams();
		this.orderNumber = params['orderNumber'];
		this.paymentId = params['paymentId'];
		this.payerId = params['PayerID'];
		
		if (!this.orderNumber || !this.paymentId || !this.payerId) {
			this.orderFailedMessage();
			return;
		}

		this.spinner();
		Ajax.rpc('/getIncompleteOrder', {
			orderNumber: this.orderNumber
		}, order => {
			order.calculation = CartWidget.calculate(order.unitPrice, order.quantity);
			$widget.html(LangUtils.isGerman() ? MAIN_DE_TEMPLATE(order) : MAIN_EN_TEMPLATE(order));
			Form.onSubmit($widget, action => {
				this.complete(action);
			});
		}, error => {
			this.orderFailedMessage();
		});
	}
	
	complete() {
		this.$widget.html(LangUtils.isGerman() ? WAIT_DE_TEMPLATE() : WAIT_EN_TEMPLATE());
		Ajax.rpc('/completePayPalOrder', {
			orderNumber: this.orderNumber,
			paymentId: this.paymentId,
			payerId: this.payerId
		}, result => {
			this.setPageHeadline(LangUtils.isGerman() ? 'Vielen Dank.' : 'Thank you.')
			this.$widget.html(LangUtils.isGerman()
				? SUCCESS_DE_TEMPLATE(result) : SUCCESS_EN_TEMPLATE(result));
		}, error => {
			this.orderFailedMessage();
		});
	}

	orderFailedMessage() {
		if (LangUtils.isGerman()) {
			MessageUtils.error(this.$widget, 'Ups! Das hat leider nicht geklappt.\n'
				+ 'Bitte versuchen Sie es später noch einmal.\n'
				+ 'Sollte das Problem bestehen bleiben, schreiben Sie bitte an ' + contactEmail());
		} else {
			MessageUtils.error(this.$widget, 'Oops! That wasn\'t successful.\n'
				+ 'Please try again later.\n'
				+ 'If this problem persists, please contact ' + contactEmail());
		}
	}

}
